import React from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';
import { contactData } from '../data/mock';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-navy text-gray-300">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Company Info */}
          <div className="lg:col-span-2">
            <div className="mb-6">
              <img 
                src="/logo.png" 
                alt="Assetree" 
                className="h-12 w-auto brightness-0 invert mb-4"
              />
              <p className="text-xs text-gray-500 italic">
                Professional Real Estate Advisory & Partnership
              </p>
            </div>
            <p className="text-gray-400 leading-relaxed mb-6">
              Assetree is a strategic real estate partner that works with residential developers to position, market, and sell apartment projects. We support developers through advisory, positioning, and sales execution with a focus on quality-led developments and transparent communication.
            </p>
            <div className="space-y-3">
              <a
                href={`mailto:${contactData.email}`}
                className="flex items-center space-x-3 text-gray-400 hover:text-gold transition-colors"
              >
                <Mail size={18} />
                <span>{contactData.email}</span>
              </a>
              <a
                href={`tel:${contactData.phone}`}
                className="flex items-center space-x-3 text-gray-400 hover:text-gold transition-colors"
              >
                <Phone size={18} />
                <span>{contactData.phone}</span>
              </a>
              <div className="flex items-start space-x-3 text-gray-400">
                <MapPin size={18} className="flex-shrink-0 mt-1" />
                <span>{contactData.address}</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-6">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('about')}
                  className="text-gray-400 hover:text-gold transition-colors"
                >
                  About Us
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('projects')}
                  className="text-gray-400 hover:text-gold transition-colors"
                >
                  Our Projects
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('why-choose')}
                  className="text-gray-400 hover:text-gold transition-colors"
                >
                  Why Choose Us
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('faq')}
                  className="text-gray-400 hover:text-gold transition-colors"
                >
                  FAQ
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="text-gray-400 hover:text-gold transition-colors"
                >
                  Contact
                </button>
              </li>
            </ul>
          </div>

          {/* Projects */}
          <div>
            <h4 className="text-white font-semibold mb-6">Our Projects</h4>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('projects')}
                  className="text-gray-400 hover:text-gold transition-colors"
                >
                  Fortune Primero
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('projects')}
                  className="text-gray-400 hover:text-gold transition-colors"
                >
                  Sobha Codename Trinity
                </button>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-navy-600 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm">
              © {currentYear} Assetree Properties Pvt. Ltd. All rights reserved.
            </p>
            <div className="flex space-x-6 text-sm">
              <a href="#" className="text-gray-400 hover:text-gold transition-colors">
                Privacy Policy
              </a>
              <a href="#" className="text-gray-400 hover:text-gold transition-colors">
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
